// extracted by mini-css-extract-plugin
export var Hero = "style-module--Hero--30-eI";
export var Title = "style-module--Title--3Myux";
export var Subtitle = "style-module--Subtitle--l4ZGc";
export var Intro = "style-module--Intro--1d-lM";
export var ImagePrefix = "style-module--ImagePrefix--3FiQY";
export var Image = "style-module--Image--3zIe6";